var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wallet-buttons" },
    [
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [
          _vm.isLoading
            ? _c("c-spinner", { staticClass: "loading" })
            : _c(
                "div",
                { staticClass: "content" },
                [
                  _vm.$can("engagement")
                    ? _c(
                        "k-button",
                        {
                          staticClass: "-alternative-button engagement-button",
                          attrs: {
                            "data-cy": "engagement-wallet-button",
                            "no-icon": ""
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.goTo("Carteira Pontos", "engajamento")
                            }
                          }
                        },
                        [
                          _c("engagement-coin", {
                            staticClass: "info",
                            attrs: {
                              coin: _vm.coin,
                              value: _vm.engagement_balance
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$can("awards")
                    ? _c(
                        "k-button",
                        {
                          staticClass: "-alternative-button award-button",
                          attrs: {
                            "data-cy": "awards-wallet-button",
                            "no-icon": ""
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.goTo("Carteira Prêmios", "premios")
                            }
                          }
                        },
                        [
                          _c("k-icon", {
                            staticClass: "wallet-icon",
                            attrs: { icon: "award-star" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Prêmio")]),
                          _vm._v(" "),
                          _c("k-icon", { attrs: { icon: "arrow-right" } }),
                          _vm._v(" "),
                          _c("b", [_vm._v(_vm._s(_vm.userAwards))])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$can("cashback_tab")
                    ? _c(
                        "k-button",
                        {
                          staticClass: "-alternative-button award-button",
                          attrs: {
                            "data-cy": "cashback-wallet-button",
                            "no-icon": ""
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.goTo("Carteira Cashback", "cashback")
                            }
                          }
                        },
                        [
                          _c("k-icon", {
                            staticClass: "wallet-icon",
                            attrs: { icon: "dollar-payments-conversion" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Cashback")]),
                          _vm._v(" "),
                          _c("k-icon", { attrs: { icon: "arrow-right" } }),
                          _vm._v(" "),
                          _c(
                            "b",
                            { class: { "-disabled": _vm.cantGetCashback } },
                            [_vm._v(_vm._s(_vm.userCashbacks))]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09b7e9b3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09b7e9b3","hasScoped":true,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/WalletButtons.vue
// module id = 2081
// module chunks = 1610